import TheRequestsPrivateMovementsDetailWrapper from '@/views/requests/private/requests/movements/TheRequestsPrivateMovementsDetailWrapper'
import TheRequestsPrivateMovementsFormView from '@/views/requests/private/requests/movements/TheRequestsPrivateMovementsFormView'
import MovementsPrivateTabbedView
    from '@/components/requests/private/requests/movements/views/MovementsPrivateTabbedView'


function detailsBackref (route) {
    return {
        name: 'accounts.private.details.requests.movements',
        params: {
            accountId: route.params.accountId,
        }
    }
}


export default [
    {
        path: 'requests/movements',
        name: 'accounts.private.details.requests.movements',
        component: MovementsPrivateTabbedView,
        meta: {
            backref: {
                name: 'accounts.private'
            },
            title: 'Перемещения ДС'
        },
        props: route => ({
            accountId: Number(route.params.accountId),
        }),
    },
    {
        path: 'requests/movements/create',
        name: 'accounts.private.details.requests.movements.create',
        component: TheRequestsPrivateMovementsFormView,
        props: route => ({
            accountId: Number(route.params.accountId),
        }),
        meta: {
            backref: detailsBackref,
            title: 'Переместить ДС'
        },
    },
    {
        path: 'requests/movements/:instanceId',
        component: TheRequestsPrivateMovementsDetailWrapper,
        props: true,

        children: [
            {
                path: '',
                name: 'accounts.private.details.requests.movements.detail',
                component: TheRequestsPrivateMovementsFormView,
                props: route => ({
                    accountId: Number(route.params.accountId),
                    movementId: Number(route.params.movementId),
                    readonly: true
                }),
                meta: {
                    backref: detailsBackref,
                    title: 'Просмотр перемещения'
                },
            },
            {
                path: 'edit',
                component: TheRequestsPrivateMovementsFormView,
                name: 'accounts.private.details.requests.movements.edit',
                props: route => ({
                    accountId: Number(route.params.accountId),
                    instanceId: Number(route.params.instanceId),
                    readonly: false
                }),
                meta: {
                    backref: detailsBackref,
                    title: 'Редактирование перемещения'
                },
            },
        ]
    },
]